import Handler from "../Handler";
class DealICMHandler extends Handler {
    // ICM mean Independent Chip Model, which is a way to calculate the value of chips in a poker tournament.
    // DealICM#{
    // "ICM": {
    //     "myth974454": {
    //         "actualPayout": 300,
    //         "icmPayout": 398.75,
    //         "win": 398.75,
    //         "bon": 0,
    //         "chipStack": 1580
    //     },
    //     "grid94983": {
    //         "actualPayout": 550,
    //         "icmPayout": 451.25,
    //         "win": 451.25,
    //         "bon": 0,
    //         "chipStack": 2420
    //     }
    // },
    // "runTime": 30
    // }

    execute(message) {
        let receivedData = JSON.parse(message);
        this.service.processDealICMProtocol(receivedData);
    }
}
export default DealICMHandler;
